import React, { useState } from "react";
import { Form, Alert } from "react-bootstrap";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import { useSendMessageMutation } from "../../store/api/apiSlice";
import { toast } from "react-toastify";
import { Button as CustomBtn } from "../../ui";

const ContactPage = () => {
  const [messageText, setMessageText] = useState("");
  const [submitBtn, setSubmitBtn] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const token = JSON.parse(localStorage.getItem("token"));
  const profileData = JSON.parse(localStorage.getItem("user"));
  const [sendMessage] = useSendMessageMutation();

  const handlesSubmit = async (e) => {
    e.preventDefault();
    setSubmitBtn(true);

    try {
      const newMessage = {
        userId: profileData?._id,
        forumId: "0",
        receiverId: "0",
        message: messageText,
        messageType: "text",
        type: "private",
        messageNote: "forAdmin",
        status: true,
      };
      const response = await sendMessage(newMessage).unwrap();
      if (response.message === "Message Created Successfully") {
        setSubmitBtn(false);
        setMessageText("");
        setSuccessMsg("Message sent successfully!");
        toast.success("Message sent successfully!");
      }
    } catch (error) {
      setSubmitBtn(false);
      toast.error("Failed to send message.");
    }
  };

  return (
    <div className="container py-5">
      <div className="border rounded shadow-sm p-4">
        <div className="d-flex align-items-center mb-4 contact_header">
          <img
            src="/images/headericon.png"
            alt="Logo"
            className="me-3 contact_header_img"
            style={{ width: "40px", height: "40px" }}
          />
          <h3 className="mb-0 contact_header_title">Contact Form</h3>
        </div>

        <div className="d-flex align-items-center mb-3">
          <FaPhone className="me-2 contact_header_text_url" />
          <a href="tel:+12052596913" className="me-4 contact_header_text_url">
            (205) 259-6913
          </a>
          <FaEnvelope className="me-2 contact_header_text_url" />
          <a
            href="mailto:voice@csfa-us.org"
            className="text-decoration-none contact_header_text_url"
          >
            voice@csfa-us.org
          </a>
        </div>

        <Form onSubmit={handlesSubmit}>
          {successMsg && <Alert variant="success">{successMsg}</Alert>}

          <Form.Group controlId="message">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Type your message here..."
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              required
            />
          </Form.Group>

          <div className="pt-3">
            <CustomBtn loading={submitBtn} type="submit" variant="primary">
              Submit
            </CustomBtn>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ContactPage;
